import { Http } from '@main/common/api'
import { EnumApiCode } from '../../../../../globalEnum.js'

const TableListMixin = {
  data () {
    return {
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {},
      // otherParam: {},
      /* 数据源 */
      tableData: [],
      /* 分页参数 */
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      /* 排序参数 */
      sort: [],
      /* table加载状态 */
      loading: false,
      /* table选中keys */
      selectedRowKeys: [],
      /* table选中records */
      selectionRows: [],
      /* table的自定义列 */
      tableColumns: [],
      disableMixinCreated: false,
      creatFlag: false
    }
  },
  created () {
    this.creatFlag = true
    if (!this.disableMixinCreated) {
      this.initDictConfig() // 初始化字典配置 在自己页面定义
      if (this.listUrl) {
        this.loadData().then()
      }
    }
    this.tableColumns = this.columns
  },
  activated () {
    if (!this.disableMixinCreated && this.creatFlag) {
      this.initDictConfig() // 初始化字典配置 在自己页面定义
      if (this.listUrl) {
        this.resetSearch()
      }
    }
  },
  methods: {
    headClass () {
      return 'background:#EDEDED;'
    },
    // 选中背景色
    tableRowClassName ({ row }) {
      return row.className
    },

    async loadData () {
      const params = {
        data: {
          ...this.queryParam,
          ...(this.otherParam || {})
        },
        ...this.pagination,
        sort: this.sort
      }
      this.loading = true
      try {
        const { data, code } = await Http.post(this.listUrl, params)
        this.loading = false
        if (code === EnumApiCode.Success) {
          this.tableData = data?.list || []
          this.pagination.total = Number(data?.total || 0)
        }
      } finally {
        this.loading = false
      }
    },
    updateColumns (columns) {
      this.tableColumns = columns
      this.$nextTick(() => {
        if (this.$refs.tableCom && this.$refs.tableCom.$refs.table.doLayout) {
          this.$refs.tableCom.$refs.table.doLayout()
        }
      })
    },
    initDictConfig () { },
    onClearSelected () {
      this.selectedRowKeys = []
      this.selectionRows = []
    },
    handleSearch () {
      this.queryParam = JSON.parse(JSON.stringify(this.searchParams || {}))
      if(this.queryParam.demandReceivingDate) {
        this.queryParam.startTime = this.queryParam.demandReceivingDate[0]
        this.queryParam.endTime = this.queryParam.demandReceivingDate[1]
      }
      if(this.queryParam.signDate) {
        this.queryParam.signDateStart = this.queryParam.signDate[0]
        this.queryParam.signDateEnd = this.queryParam.signDate[1]
      }
      if(this.queryParam.createTime) {
        this.queryParam.createDateStart = this.queryParam.createTime[0]
        this.queryParam.createDateEnd = this.queryParam.createTime[1]
      }
      this.pagination.pageNum = 1
      this.loadData().then()
    },
    resetSearch () {
      this.$refs.selectTreeAnalysis && (this.$refs.selectTreeAnalysis.selectName = '')
      this.$refs.selectTreeAnalysis && (this.$refs.selectTreeAnalysis.selectVal = '')
      this.$refs.libPicker && this.$refs.libPicker.handleClean()
      this.$refs.signDateRef && this.$refs.signDateRef.handleClean()
      this.$refs.createTimeRef && this.$refs.createTimeRef.handleClean()
      this.queryParam = {}
      this.searchParams = {}
      this.pagination.pageNum = 1
      this.loadData().then()
    },
    onSelectionChange (selection) {
      let resetSelection = selection
      if (selection.length > 0) {
        resetSelection = selection.map((item) => {
          return {
            ...item,
            className: 'selected-row-bg'
          }
        })
      }
      this.handleSelectionChange(resetSelection)
    },
    handleSelectionChange (selectionRows) {
      this.selectedRowKeys = selectionRows.map((item) => item.id)
      this.selectionRows = selectionRows
    },
    onSortChange (value) {
      this.handleTableChange(this.pagination, value)
    },
    handleTableChange (pagination, sorter, filters) {
      // 因onSortChange和onPageChange是同一个方法  导致页码改变后无法携带排序参数 添加此条件做判断
      if (sorter !== 'isPageChange') {
        if (sorter && sorter.order !== null) {
          this.sort = [
            {
              field: sorter.prop,
              type: sorter.order === 'ascending' ? 'asc' : 'desc'
            }
          ]
        } else {
          this.sort = []
        }
      }
      if (typeof filters !== 'undefined') {
        // 服务端筛选
      }
      this.pagination = pagination ? Object.assign(this.pagination, pagination) : this.pagination
      this.loadData().then()
    },
    handleTableConfig () {
      this.$refs.tableConfigDrawer.open()
    },
    handleCheck (value) {
      this.columns = value
    },
    async handleExport (exportUrl, val) {
      const includeFieldNames = this.tableColumns.map((v) => v.prop)
      const param = {
        ...this.queryParam,
        ...(this.otherParam || {}),
        ...val,
        includeFieldNames // 指定导出的字段
        // excludeFieldNames:  // 不需要导出的字段
      }
      try {
        const { code, data } = await Http.post(exportUrl, param)
        if (code === EnumApiCode.Success) {
          // this.$message.success('正在导出,请去下载中心下载')
          return data
        }
      } finally {
        this.loading = false
      }
    }
  }
}
export default TableListMixin
